import { css } from '@emotion/css';
import { cssObj } from '@/css/resources/functions.css';
import {
	resetFirstMarginTop,
	resetFirstLastMargins,
	textDefaultStyles,
} from '@/css/resources/placeholders.css';
import {
	fontStyle,
	fluidBorderWidth,
	fluidBorderRadius,
} from '@/css/resources/mixins.css';
import { zIndex } from '@/css/resources/variables.css';

const getDynamicStyles = (styles) =>
	cssObj({
		/* backdrop */
		'&::after': {
			background: styles?.backdropColor,
		},

		'.supt-gdprModal__content': cssObj(
			fluidBorderWidth(styles?.border?.width),
			fluidBorderRadius(styles?.border?.radius),
			{
				background: styles?.backgroundColor,
				borderColor: styles?.border?.color,
			}
		),

		'.supt-gdprModal__close': {
			svg: {
				stroke: styles?.closeButton?.color,
			},
		},

		'.supt-gdprModal__title': fontStyle({
			...styles?.title?.typography,
			textAlign: styles?.title?.textAlignment,
			color: styles?.title?.color,
		}),

		'.supt-gdprModal__desc': fontStyle({
			...styles?.text?.typography,
			textAlign: styles?.text?.textAlignment,
			color: styles?.text?.color,
		}),
	});

const getStyles = (styles) =>
	css(
		{
			position: 'fixed',
			top: 0,
			right: 0,
			bottom: 0,
			left: 0,
			zIndex: zIndex.gdprModal,
			transform: 'scale(1)',
			overflow: 'hidden',
			outline: 0,

			/* backdrop */
			'&::after': {
				content: '""',
				position: 'fixed',
				top: 0,
				right: 0,
				bottom: 0,
				left: 0,
				zIndex: 1,
				display: 'block',
				width: '100vw',
				height: '100vh',
				opacity: 0.7,
				transform: 'scale(1)',
				transition: 'opacity ease-in-out 0.5s',
			},

			'.supt-gdprModal__dialog': {
				position: 'relative',
				zIndex: 10,
				width: 'auto',
				margin: '0.5rem',
				pointerEvents: 'none',
				display: 'flex',
				alignItems: 'center',
				minHeight: 'calc(100% - (0.5rem * 2))',

				'@media (min-width: 576px)': {
					maxWidth: '500px',
					margin: '1.75rem auto',
					minHeight: 'calc(100% - (1.75rem * 2))',
				},

				'@media (min-width: 992px)': {
					maxWidth: '650px',
				},
			},

			'.supt-gdprModal__content': {
				position: 'relative',
				display: 'flex',
				flexDirection: 'column',
				width: '100%',
				pointerEvents: 'auto',
				outline: 0,
				padding: '35px 25px',
				borderStyle: 'solid',
			},

			'.supt-gdprModal__close': {
				position: 'absolute',
				right: 0,
				top: '2px',
				zIndex: 1,
				width: '40px',
				height: '40px',
				padding: '10px',
				background: 'none',
				border: 'none',
				cursor: 'pointer',

				svg: {
					strokeWidth: '2px',
					transform: 'scale(1)',
					transition: 'transform 0.2s ease-out',
				},

				'&:hover': {
					svg: {
						transform: 'scale(1.1)',
					},
				},
			},

			'.supt-gdprModal__body': {
				maxHeight: '80vh',
				overflow: 'auto',

				/* For the scroll bar */
				marginRight: '-20px',
				paddingRight: '20px',
			},

			'.supt-gdprModal__head': {
				position: 'static',
				pointerEvents: 'auto',
			},

			'.supt-gdprModal__title': resetFirstLastMargins,

			'.supt-gdprModal__text': cssObj(
				resetFirstMarginTop,
				textDefaultStyles
			),

			'.supt-gdprModal__categories': {
				listStyle: 'none',
				padding: 0,
				margin: 0,

				'> *:not(:first-child)': {
					marginTop: '10px',
				},
			},

			'.supt-gdprModal__footer': {
				width: '100%',
				textAlign: 'right',
				position: 'static',
				opacity: 1,
				display: 'flex',
				justifyContent: 'flex-end',
			},

			'.supt-gdprModal__saveButton': {
				cursor: 'pointer',
				marginBottom: '0px',
			},

			/**
			 * STATES
			 */
			'&[aria-hidden="true"]': {
				display: 'none',
			},
		},
		getDynamicStyles(styles)
	);

export { getStyles };
